// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    aplicativos: path(ROOTS_DASHBOARD, '/aplicativos'),
    transferencias: path(ROOTS_DASHBOARD, '/transferencias'),
    busca: path(ROOTS_DASHBOARD, '/busca'),
    dispositivosConfigurar: path(ROOTS_DASHBOARD, '/dispositivos/configurar'),
    novidades: path(ROOTS_DASHBOARD, '/novidades'),
    // Perfil do PROPRIO usuario logado. Sem `:id` de proposito: o id vem do token
    // (GET /users/eu), entao nao ha numero na URL para alguem trocar e espiar o
    // perfil de outra pessoa.
    perfil: path(ROOTS_DASHBOARD, '/perfil'),
    // Mural de avisos: leitura para todos, publicacao so para Master.
    avisos: path(ROOTS_DASHBOARD, '/avisos'),
    manual: path(ROOTS_DASHBOARD, '/manual'),
    regionais: path(ROOTS_DASHBOARD, '/regionais'),
    regionaisAcessos: path(ROOTS_DASHBOARD, '/regionais/acessos'),
    // Modulo de mensagens virou TICKETS (com SLA e feriados).
    // `mensagens` fica como alias apontando para a mesma rota para nao quebrar
    // link salvo/favorito de quem ja usava a URL antiga.
    tickets: path(ROOTS_DASHBOARD, '/tickets'),
    ticketsFeriados: path(ROOTS_DASHBOARD, '/tickets/feriados'),
    ticketsCategorias: path(ROOTS_DASHBOARD, '/tickets/categorias'),
    mensagens: path(ROOTS_DASHBOARD, '/tickets'),
    comunicados: path(ROOTS_DASHBOARD, '/comunicados'),
    sistemas: path(ROOTS_DASHBOARD, '/sistemas'),
    entidades: path(ROOTS_DASHBOARD, '/entidades'),
    // dispositivos: path(ROOTS_DASHBOARD, '/entidades/dispositivos/-1'),
    dispositivos: path(ROOTS_DASHBOARD, '/dispositivos/-1'),
    apks: path(ROOTS_DASHBOARD, '/apks'),
    politicas: path(ROOTS_DASHBOARD, '/politicas'),
    users: path(ROOTS_DASHBOARD, '/users'),
    chave_acesso: path(ROOTS_DASHBOARD, '/chave_acesso'),
    logs: path(ROOTS_DASHBOARD, '/logs'),
    monitoramento: path(ROOTS_DASHBOARD, '/monitoramento'),
    // dispositivos: path(ROOTS_DASHBOARD, '/dispositivos'),

    // ------------------------------------------------------------------------
    // VISUAL NOVO (shadcn + Tailwind) - rotas paralelas.
    //
    // As telas acima continuam existindo e funcionando; estas sao as versoes
    // reescritas, para as quais o menu aponta. Manter as duas permite comparar
    // lado a lado com dado real e voltar atras trocando UMA linha no NavConfig,
    // sem restaurar arquivo nenhum.
    //
    // Quando as novas estiverem validadas em uso, o caminho e: apagar a tela
    // antiga, renomear o diretorio `-novo` para o nome original e remover estas
    // entradas. Ate la, NAO apagar as antigas - as paginas de criar/editar ainda
    // vivem dentro delas (ex.: /entidades/new/:id).
    // ------------------------------------------------------------------------
    aplicativosNovo: path(ROOTS_DASHBOARD, '/aplicativos-novo'),
    entidadesNovo: path(ROOTS_DASHBOARD, '/entidades-novo'),
    politicasNovo: path(ROOTS_DASHBOARD, '/politicas-novo'),
    apksNovo: path(ROOTS_DASHBOARD, '/apks-novo'),
    usersNovo: path(ROOTS_DASHBOARD, '/users-novo'),
    regionaisNovo: path(ROOTS_DASHBOARD, '/regionais-novo'),
    dispositivosNovo: path(ROOTS_DASHBOARD, '/dispositivos-novo/-1'),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  users: {
    root: path(ROOTS_DASHBOARD, '/users'),
    new: path(ROOTS_DASHBOARD, '/users/new'),
    list: path(ROOTS_DASHBOARD, '/users/list'),
    dispositivos: (name) => path(ROOTS_DASHBOARD, `/users/dispositivos/${name}`),
     cards: path(ROOTS_DASHBOARD, '/users/cards'),
    profile: path(ROOTS_DASHBOARD, '/users/profile'),
    account: path(ROOTS_DASHBOARD, '/users/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/users/new/${name}`),
    new: (name) => path(ROOTS_DASHBOARD, `/users/new/${name}`),
    view: (name) => path(ROOTS_DASHBOARD, `/users/cadastro/${name}`),
    demoEdit: path(ROOTS_DASHBOARD, `/users/reece-chung/edit`),
  },
  chave_acesso: {
    root: path(ROOTS_DASHBOARD, '/chave_acesso'),
  },
  entidades: {
    root: path(ROOTS_DASHBOARD, '/entidades'),
    new: path(ROOTS_DASHBOARD, '/entidades/new'),
    list: path(ROOTS_DASHBOARD, '/entidades/list'),
    dispositivos: (name) => path(ROOTS_DASHBOARD, `/dispositivos/${name}`),
    item: (dispositivo, itemValue) => path(ROOTS_DASHBOARD, `/dispositivos/${dispositivo}/item/${itemValue}`),
    cards: path(ROOTS_DASHBOARD, '/entidades/cards'),
    profile: path(ROOTS_DASHBOARD, '/entidades/profile'),
    account: path(ROOTS_DASHBOARD, '/entidades/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/entidades/new/${name}`),
    new: (name) => path(ROOTS_DASHBOARD, `/entidades/new/${name}`),
    view: (name) => path(ROOTS_DASHBOARD, `/entidades/cadastro/${name}`),
    demoEdit: path(ROOTS_DASHBOARD, `/entidades/reece-chung/edit`),
  },
  aplicativos: {
    root: path(ROOTS_DASHBOARD, '/aplicativos'),
    new: path(ROOTS_DASHBOARD, '/aplicativos/new'),
    list: path(ROOTS_DASHBOARD, '/aplicativos/list'),
    dispositivos: (name) => path(ROOTS_DASHBOARD, `/aplicativos/dispositivos/${name}`),
     cards: path(ROOTS_DASHBOARD, '/aplicativos/cards'),
    profile: path(ROOTS_DASHBOARD, '/aplicativos/profile'),
    account: path(ROOTS_DASHBOARD, '/aplicativos/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/aplicativos/new/${name}`),
    new: (name) => path(ROOTS_DASHBOARD, `/aplicativos/new/${name}`),
    view: (name) => path(ROOTS_DASHBOARD, `/aplicativos/cadastro/${name}`),
    demoEdit: path(ROOTS_DASHBOARD, `/aplicativos/reece-chung/edit`),
  },
  regionais: {
    root: path(ROOTS_DASHBOARD, '/regionais'),
    new: path(ROOTS_DASHBOARD, '/regionais/new'),
    list: path(ROOTS_DASHBOARD, '/regionais/list'),
    cards: path(ROOTS_DASHBOARD, '/regionais/cards'),
    profile: path(ROOTS_DASHBOARD, '/regionais/profile'),
    account: path(ROOTS_DASHBOARD, '/regionais/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/regionais/new/${name}`),
    new: (name) => path(ROOTS_DASHBOARD, `/regionais/new/${name}`),
    view: (name) => path(ROOTS_DASHBOARD, `/regionais/cadastro/${name}`),
    demoEdit: path(ROOTS_DASHBOARD, `/regionais/reece-chung/edit`),
  },
  dispositivos: {
    root: path(ROOTS_DASHBOARD, '/dispositivos/-1'),
    list: path(ROOTS_DASHBOARD, '/dispositivos/-1'),
    name: (name) => path(ROOTS_DASHBOARD, `/dispositivos/${name}`),
    item: (dispositivo, itemValue) => path(ROOTS_DASHBOARD, `/dispositivos/${dispositivo}/item/${itemValue}`),


  },
  transferencias: {
    root: path(ROOTS_DASHBOARD, '/transferencias'),
    list: path(ROOTS_DASHBOARD, '/transferencias'),
  },
  busca: {
    root: path(ROOTS_DASHBOARD, '/busca'),
    list: path(ROOTS_DASHBOARD, '/busca'),
  },
  novidades: {
    root: path(ROOTS_DASHBOARD, '/novidades'),
    list: path(ROOTS_DASHBOARD, '/novidades'),
  },
  manual: {
    root: path(ROOTS_DASHBOARD, '/manual'),
    list: path(ROOTS_DASHBOARD, '/manual'),
  },
  apks: {
    root: path(ROOTS_DASHBOARD, '/apks'),
    new: path(ROOTS_DASHBOARD, '/apks/new'),
    list: path(ROOTS_DASHBOARD, '/apks/list'),
    dispositivos: (name) => path(ROOTS_DASHBOARD, `/apks/dispositivos/${name}`),
     cards: path(ROOTS_DASHBOARD, '/apks/cards'),
    profile: path(ROOTS_DASHBOARD, '/apks/profile'),
    account: path(ROOTS_DASHBOARD, '/apks/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/apks/new/${name}`),
    new: (name) => path(ROOTS_DASHBOARD, `/apks/new/${name}`),
    view: (name) => path(ROOTS_DASHBOARD, `/apks/cadastro/${name}`),
    demoEdit: path(ROOTS_DASHBOARD, `/apks/reece-chung/edit`),
  },
  politicas: {
    root: path(ROOTS_DASHBOARD, '/politicas'),
    new: path(ROOTS_DASHBOARD, '/politicas/new'),
    list: path(ROOTS_DASHBOARD, '/politicas/list'),
    dispositivos: (name) => path(ROOTS_DASHBOARD, `/politicas/dispositivos/${name}`),
    item: (dispositivo, itemValue) => path(ROOTS_DASHBOARD, `/politicas/dispositivos/${dispositivo}/item/${itemValue}`),
    cards: path(ROOTS_DASHBOARD, '/politicas/cards'),
    profile: path(ROOTS_DASHBOARD, '/politicas/profile'),
    account: path(ROOTS_DASHBOARD, '/politicas/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/politicas/new/${name}`),
    new: (name) => path(ROOTS_DASHBOARD, `/politicas/new/${name}`),
    view: (name) => path(ROOTS_DASHBOARD, `/politicas/cadastro/${name}`),
    demoEdit: path(ROOTS_DASHBOARD, `/politicas/reece-chung/edit`),
  },
  // Formulario de politica no visual novo. Rota PARALELA: a tela antiga continua
  // publicada, porque esta e a unica tela do sistema em que um campo trocado nao
  // da erro na interface - vai para o `policies.patch` do Google e muda o
  // comportamento de aparelho em campo. Com as duas vivas da para comparar o
  // corpo enviado pelas duas versoes antes de trocar o link do menu.
  politicasNovo: {
    root: path(ROOTS_DASHBOARD, '/politicas-novo'),
    edit: (name) => path(ROOTS_DASHBOARD, `/politicas-novo/new/${name}`),
    copiar: (name) => path(ROOTS_DASHBOARD, `/politicas-novo/new/0?copiarDe=${name}`),
  },
  comunicados: {
    root: path(ROOTS_DASHBOARD, '/comunicados'),
    new: path(ROOTS_DASHBOARD, '/comunicados/new'),
    list: path(ROOTS_DASHBOARD, '/comunicados/list'),
    cards: path(ROOTS_DASHBOARD, '/comunicados/cards'),
    profile: path(ROOTS_DASHBOARD, '/comunicados/profile'),
    account: path(ROOTS_DASHBOARD, '/comunicados/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/comunicados/cadastro/${name}`),
    post: (name) => path(ROOTS_DASHBOARD, `/comunicados/post/${name}`),
    view: (name) => path(ROOTS_DASHBOARD, `/comunicados/cadastro/${name}`),
    demoEdit: path(ROOTS_DASHBOARD, `/comunicados/reece-chung/edit`),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: (title) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  },
  empresa: {
    root: path(ROOTS_DASHBOARD, '/empresa'),
    view: (id) => path(ROOTS_DASHBOARD, `/empresa/${id}`),

  },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';


